var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticStyle:{"vertical-align":"top","text-align":"left","padding":"12px 0"},attrs:{"span":_vm.span,"xs":_vm.xs,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl,"offset":_vm.offset,"push":_vm.push,"pull":_vm.pull}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-19c7c7f6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/Col/index.vue
// module id = 645
// module chunks = 0